import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  menuOpen: false,
};

export const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    toggleMenu: (state, action) => {
      state.menuOpen = action.payload;
    },
  },
});

export const { toggleMenu } = uiSlice.actions;
export default uiSlice.reducer;
